import React from "react";
import { useTranslation } from "react-i18next";
import type { ThemeVariables } from "../../../types"; // Import ThemeVariables

interface InvalidOrderMessageProps {
  messageKey: string; // Key for the specific error message
  defaultMessage: string; // Fallback message
}

const InvalidOrderMessage: React.FC<InvalidOrderMessageProps> = ({
  messageKey,
  defaultMessage,
}) => {
  const { t } = useTranslation();

  // Get Shop Page URL from Theme Variables
  const themeVars = window.themeVariables as ThemeVariables | undefined;
  const shopUrl = themeVars?.shopPageUrl || "/"; // Provide a fallback

  return (
    <div className="order-invalid-message">
      {/* Display the message using the provided key */}
      <p className="order-error-message">{t(messageKey, defaultMessage)}</p>
      {/* Link back to shop */}
      <a href={shopUrl} className="button shop-link">
        {t("order.backToShop", "Back to Shop")}
      </a>
    </div>
  );
};

export default InvalidOrderMessage;
